import fallbackImg from '../../assets/user.png'; // Import the fallback image

export const userColumns = [
  { 
    field: "id",
    headerName: "ID",
    width: 200 
  },
  {
    field: "user",
    headerName: "Image",
    width: 30,
    renderCell: (params) => {
      const imgSrc = params.row.userImage || fallbackImg; // Use fallback image if img is null
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imgSrc}
            alt="avatar"
            onError={(e) => e.target.src = fallbackImg} // Fallback on error
          />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "userName",
    headerName: "Name",
    width: 200,
  },
  {
    field: "contest_id",
    headerName: "Contes ID",
    width: 200,
  },
  {
    field: "userPhone",
    headerName: "Email",
    width: 200,
  },
  {
    field: "status",
    headerName: "Status",
    width: 70,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
